export default (theme) => ({
    lightgreyBackground: {
        backgroundColor: "lightgrey",
    },
    darkBorderTop: {
        borderTop: "2px solid black",
    },
    lightBorderTop: {
        borderTop: "2px solid #bababa",
    },
});
